module.exports = __webpack_public_path__ + "static/img/14000051.259a6ce0.png";